import { FormValidator, ValidationResult } from '../formField/types/form-validator';
import { HostnameValidator } from './hostname.validator';
import { MultipleIpsValidator } from './multiple-ips.validator';

export const AddressValidator: (errorMessage: string, allowPath?: boolean) => FormValidator = (
  errorMessage: string,
  allowPath: boolean = false
) => {
  return async (value: string): Promise<ValidationResult> => {
    let address = value;

    // remove http:// from the beginning of the address
    if (address.search('http://') === 0) {
      address = address.replace('http://', '');
    }

    // remove https:// from the beginning of the address
    if (address.search('https://') === 0) {
      address = address.replace('https://', '');
    }

    // remove / from the end of the address
    if (address.slice(-1) === '/') {
      address = address.slice(0, -1);
    }

    // validate hostname
    const hostnameValidationResult: ValidationResult = await HostnameValidator(errorMessage, true, allowPath)(address);
    if (hostnameValidationResult.valid) {
      return hostnameValidationResult;
    }

    // validate multiple IPs
    const multipleIpsValidationResult: ValidationResult = await MultipleIpsValidator(errorMessage)(address);
    if (multipleIpsValidationResult.valid) {
      return multipleIpsValidationResult;
    }

    return { valid: false, error: errorMessage };
  };
};
